import { SvgContainer } from "../../styled";
import { useEffect, useState } from "react";
import { RadarImage } from "./styled";

const DEFAULT_BG_URL = "/images/radar/bg.svg";

export type BackgroundProps = {
  settings: Record<string, any>;
};

function Background({ settings }: BackgroundProps) {
  const [svgData, setSvgData] = useState<string>("");
  const radarBackground = settings?.radarBackground?.value;
  const radarBackgroundRear = settings?.radarBackgroundRear?.value;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(DEFAULT_BG_URL);
        setSvgData(await res.text());
      } catch {
        /* empty */
      }
    };

    if (!radarBackground) {
      fetchData();
    }
  }, [radarBackground]);

  return svgData ? (
    <SvgContainer
      viewBox="0 0 1150 1080"
      dangerouslySetInnerHTML={{ __html: svgData }}
    />
  ) : (
    <RadarImage
      src={radarBackground}
      alt="Radar Background"
      className="custom-radar-bg-image"
      style={
        radarBackgroundRear
          ? {
              backgroundImage: `url("${radarBackgroundRear}")`,
            }
          : undefined
      }
    />
  );
}
export default Background;
